export default __webpack_public_path__ + "4d25b7833c033d6e2380ec4ecc988d66.png";